<p-toast></p-toast>
<div class="card">
  <h2>Solicitud de Canje</h2>  
  <form [formGroup]="canjeForm" (ngSubmit)="onSubmit()">
    <div class="formgrid grid">      
            <!-- Redimir  -->
        <div class="field col-12 md:col-12">
            <label for="redimir">Cantidad</label>
            <p-inputNumber formControlName="redimir" inputId="redimir" 
            placeholder="Ingrese la cantidad" styleClass="inputnumber"
            [maxlength]="8"
            [max]="999999"
            [ngClass]="{'ng-invalid ng-dirty': f['redimir'].touched && f['redimir'].errors}"></p-inputNumber>    
          
          <small class="p-error" *ngIf="f['redimir'].touched && f['redimir'].errors?.['required']">
            La cantidad es requerida
        </small>
        </div>
         <!-- fecha -->
        <div class="field col-12 md:col-12">
            <label for="fecha">Fecha *:</label>    
            <p-calendar id="fecha" formControlName="fechaInicio"  
            dateFormat="dd/mm/yy"    
            placeholder="Ingrese la fecha" 
            [ngClass]="{'ng-invalid ng-dirty': f['fechaInicio'].touched && f['fechaInicio'].errors}"               
            ></p-calendar>
            <small class="p-error" *ngIf="f['fechaInicio'].touched && f['fechaInicio'].errors?.['required']">
              La fecha es requerida
          </small>
        </div>
          <!-- Descripcion  -->
        <div class="field col-12 md:col-12">
            <label for="descripcion">Descripcion</label>
            <input 
              id="descripcion"
              type="text"
              pInputText
              [maxlength]="120"
              formControlName="descripcion"
              class="text-base text-color surface-overlay p-2 border-1 border-solid surface-border border-round appearance-none outline-none focus:border-primary w-full"
              [ngClass]="{'ng-invalid ng-dirty': f['descripcion'].touched && f['descripcion'].errors}">
              <small class="p-error" *ngIf="f['descripcion'].touched && f['descripcion'].errors?.['required']">
                El concepto es requerido
            </small>
        </div>
    </div>
     <!-- Botones -->
    <div class="field col-12 md:col-4">
        <button 
        type="submit"
        class="pi pi-save"
        [disabled]="canjeForm.invalid"> Guardar
        </button>
    </div> 
  </form>  
</div>